import { useGrowthbook, getExperimentBranchFeatureKey } from '@experience/core-hostapp-share-lib';
import { onMounted } from 'vue';

/**
 * Отправляет состояние эксперимента на ветке в growthbook.
 *
 * По архитектурным причинам может быть включен только один эксперимент в одном МФ.
 *
 * @param experimentName имя эксперимента без префикса `experiment-branch-`
 */
export const trackBranchExperiment = (experimentName?: string) => {
  if (!experimentName) {
    return;
  }

  onMounted(() => {
    const gb = useGrowthbook();

    gb?.isOn(getExperimentBranchFeatureKey(experimentName));
  });
};
